<app-modal [header]="'Fechar ocorrência'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>
    <div class="text-xs mb-10 space-y-2">
      <p>Ao fechar uma ocorrência, não poderá efectuar nenhuma operação. A mesma passará para o estado "Terminado" e
        deixará
        de estar visível para o público geral. Adicionalmente todos os pedidos de contacto serão removidos.
    </div>

    <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="my-10">

        <app-select-input [formGroup]="form" id="outcome" [options]="decisions" [formError]="outcomeFormError"
                          placeholder="Conseguiu encontrar o que procura?" label="Conseguiu encontrar o que procura?"
        ></app-select-input>

      </div>

      <hr>

      <!-- submit button -->
      <div class="flex justify-end">
        <app-ae-button variant="success" label="Fechar ocorrência" [loading]="isLoading"
                  (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
      </div>
    </form>
  </div>


</app-modal>


